import CryptoJS from 'crypto-js'

export function encrypt (word, keyStr, ivStr) {
  keyStr = keyStr || 'L+~f4,Ir)b$=pkfb'
  ivStr = ivStr || 'L+~f4,Ir)b$=pkfb'

  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const iv = CryptoJS.enc.Utf8.parse(ivStr)
  const srcs = CryptoJS.enc.Utf8.parse(word)

  return CryptoJS.AES.encrypt(srcs, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

export function decrypt (word, keyStr, ivStr) {
  keyStr = keyStr || 'L+~f4,Ir)b$=pkfb'
  ivStr = ivStr || 'L+~f4,Ir)b$=pkfb'
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  const iv = CryptoJS.enc.Utf8.parse(ivStr)

  const decryptResult = CryptoJS.AES.decrypt(word, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  try {
    return decryptResult.toString(CryptoJS.enc.Utf8)
  } catch (e) {
    return decryptResult
  }
}



// WEBPACK FOOTER //
// ./src/utils/Crypto.js